<template>
  <el-row :gutter="24" style="height: 100%; margin: 0px; padding: 5px 5px; overflow-y: hidden;">
    <el-header height="auto" style="padding: 10px 30px">
      <el-row type="flex" justify="start">
        <span style="color: #505155; font-weight: bold; font-size: 20px">
          Assinaturas Eletrônicas
        </span>
      </el-row>
    </el-header>
    <el-col :span="4" style="height: 100% ;padding: 30px 0px 50px 0px; overflow-y: auto;">
      <div style="display: flex; flex-direction: row; margin: 5px 15px 0px 15px; padding-bottom: 10px; border-bottom: 1px solid #d4cece;">
        <i><font-awesome-icon icon="filter"/></i> Filtros
      </div>
      <div style="display: flex; flex-direction: column; overflow-y: auto;">
        <el-form :model="assinaturaPesquisa">
          <el-form-item label="Status: ">
            <el-select
              v-model="assinaturaPesquisa.status"
              style="width: 100%;"
            >
              <el-option v-for="item in statusAssinatura"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="Data: ">
            <el-date-picker
              auto-complete="off"
              v-model="assinaturaPesquisa.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
              placeholder="Data Inicial"
            />
            <span>Até</span>
            <el-date-picker
              auto-complete="off"
              v-model="assinaturaPesquisa.dataFinal"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
              placeholder="Data Final"
            />
          </el-form-item>

          <el-form-item label="Aluguel">
            <el-select
              v-model="assinaturaPesquisa.aluguel"
              :remote-method="recuperarAlugueisSelect"
              :loading="loadingAlugueis"
              value-key="id"
              placeholder=""
              loading-text="Carregando Alugueis"
              no-data-text="Nenhum aluguel encontrado"
              filterable
              clearable
              @clear="assinaturaPesquisa.aluguel = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in listaAlugueis"
                :key="item.id"
                :label="`${item.idNaImobiliaria} - ${item.imovel.endereco} (${item.imovel.bairro.nome})`"
                :value="item"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="Venda">
            <el-select
              v-model="assinaturaPesquisa.venda"
              :remote-method="recuperarVendasSelect"
              :loading="loadingVendas"
              value-key="id"
              placeholder=""
              loading-text="Carregando Alugueis"
              no-data-text="Nenhum aluguel encontrado"
              filterable
              clearable
              @clear="assinaturaPesquisa.venda = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in listaVendas"
                :key="item.id"
                :label="`${item.imovel.idNaImobiliaria} - ${item.imovel.endereco} (${item.imovel.bairro.nome})`"
                :value="item"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="Imóvel">
            <el-select
              v-model="assinaturaPesquisa.imovelAluguel"
              :remote-method="recuperarImoveisSelect"
              :loading="loadingImoveis"
              value-key="id"
              placeholder=""
              loading-text="Carregando Imóveis de Aluguel"
              no-data-text="Nenhum imóvel de aluguel"
              filterable
              clearable
              @clear="assinaturaPesquisa.imovelAluguel = undefined"
              remote
              reserve-keyword
              style="width: 100%;"
            >
              <el-option
                v-for="item in listaImoveis"
                :key="item.id"
                :label="`${item.idNaImobiliaria} - ${ item.endereco }(${item.bairro.nome})`"
                :value="item"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="Vistoria">
            <el-select
              v-model="assinaturaPesquisa.vistoria"
              :remote-method="recuperarVistoriasSelect"
              :loading="loadingVistorias"
              value-key="id"
              placeholder=""
              loading-text="Carregando Vistorias"
              no-data-text="Nenhuma Vistoria encontrada."
              filterable
              clearable
              @clear="assinaturaPesquisa.vistoria = undefined"
              remote
              reserve-keyword
              style="width: 100%;"
            >
              <el-option
                v-for="item in listaVistorias"
                :key="item.id"
                :label="`Vistoria de ${item.tipo[0] + item.tipo.slice(1).toLowerCase().replace('_', ' ')} - Aluguel: ${item.aluguel.idNaImobiliaria}, Imovel: ${item.imovel.idNaImobiliaria}, Status: ${ item.status[0] + item.status.slice(1).toLowerCase()}`"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div style="display: flex; flex-direction: row; align-items: flex-end;">
        <el-button @click="limparPesquisa" icon="el-icon-brush" round class="btn-box-shadow" size="small" type="warning">Limpar</el-button>
        <el-button @click="listarAssinaturasHandler" icon="el-icon-search" round class="btn-box-shadow" size="small" type="success">Aplicar</el-button>
      </div>
    </el-col>
    <el-col :span="20" style="height: 100%;">
      <el-container class="full-height">
        <el-main class="border full-height;" style="padding: 10px; background-color: white;">
          <el-row class="full-height">
            <el-col :span="24" class="full-height">
              <el-main class="full-height">

                <el-table
                  :data="listaAssinaturas"
                  empty-text="Nenhum registro encontrado"
                  size="small"
                  style="background-color: #FFFFFF; border: solid 1px #DBDFE5; border-radius: 5px; font-size: 17px; overflow: scroll; padding: 20px;"
                  highlight-current-row
                  stripe
                  class="height-table bg-row-table">
                  <el-table-column>
                    <template slot-scope="scope">
                      <!--TITULO-->
                      <el-row :gutter="10" style="font-size: 18px; font-weight: 600; padding: 10px 0px; background-color:beige; border-top-right-radius: 10px; border-top-left-radius: 10px; width: calc(100% - 35px);">
                        <el-col :span="24" style="display: flex; flex-direction: row; justify-content: space-between;">
                          <span>Assinatura de {{ `${getLabel(tipoDeAssinatura, scope.row.tipo)}` }}</span>
                          <span
                          :style="`background-color: ${scope.row.status == 'NOVA_ASSINATURA' ? '#58ACFA' :
                              scope.row.status == 'EM_PROCESSO' ? '#FACC2E' :
                                                              scope.row.status == 'EM_PROCESSO' ? '#FACC2E' : 
                              scope.row.status == 'EM_PROCESSO' ? '#FACC2E' :
                                scope.row.status == 'FINALIZADO' ? '#64FE2E' :
                                  '#FE2E2E'}; width: 200px; display: flex; justify-content: center; border-radius: 10px; font-size:12px; color: #FFFFFF`"
                          >
                            {{ getLabel(statusAssinatura, scope.row.status) }}
                          </span>
                        </el-col>
                      </el-row>

                      <el-row :gutter="24" style="font-size: 13px; padding: 5px;">
                        
                        <el-col :span="14" style="font-size: 15px; color: black;">
                          <el-button @click="showSignatarios(scope.row.id)" type="text">Signatários Adicionados <i
                              :class="idsExibirSignatario.includes(scope.row.id) ? 'el-icon-zoom-out' : 'el-icon-zoom-in'"></i></el-button>
                          <el-collapse-transition>
                            <div v-show="idsExibirSignatario.includes(scope.row.id)"
                              style="font-size: 12px; padding-left: 2px;">
                              <div v-if="scope.row.signatarios">
                                <div v-for="item in scope.row.signatarios" :key="item.id" style="display: flex; flex-direction: row; justify-content: space-between;">
                                  <span>{{ `${item.nome}: ${scope.row.tipo === 'ALUGUEL' ?
                                    getLabel(tiposSignatarioAluguel,
                                      item.tipoSignatario) :
                                    scope.row.tipo === 'VENDA' ? getLabel(tiposSignatarioVenda, item.tipoSignatario)
                                      :
                                      scope.row.tipo === 'IMOVEL_ALUGUEL' ? getLabel(tiposSignatarioImovelAluguel,
                                        item.tipoSignatario) : ''
                                    }` }}</span>
                                  <span>
                                    <span>
                                      <i 
                                        :class="item.statusAssinatura === 'EM_ESPERA' ? 'el-icon-time' : 'el-icon-circle-check' "
                                        :style="{ color: item.statusAssinatura === 'EM_ESPERA' ? 'orange'  : 'green', marginLeft: '10px'}"
                                      >
                                      </i>
                                      Status: 
                                      </span><span>{{ getLabel(statusAssinaturaSignatario, item.statusAssinatura) }}</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </el-collapse-transition>
                        </el-col>
                        <el-col :span="5">
                          <span v-if="scope.row.aluguel.id > 0">ID do Aluguel: {{ scope.row.aluguel.idNaImobiliaria }}</span>
                          <span v-if="scope.row.venda.id > 0">ID da Venda: {{ scope.row.venda.imovel.idNaImobiliaria }}</span>
                          <span v-if="scope.row.imovel.id > 0">ID do Imovel: {{ scope.row.imovel.idNaImobiliaria }}</span>
                          <span v-if="scope.row.proposta">ID do Atendimento: {{ scope.row.proposta.atendimento.id }}</span>
                        </el-col>
                       
                      </el-row>
                    </template>
                  </el-table-column>
                </el-table>

              </el-main>
            </el-col>
          </el-row>
        </el-main>
        <el-button @click="exibirCriarAssinaturaDialog" class="add-button" style="position: absolute; top: 84%; left: 94%; border-radius: 100px; width: 54px; height: 54px;">
          <i class="el-icon-plus" style="font-weight: bold; color: whitesmoke;"></i>
        </el-button>
        <app-criar-assinatura @close="fecharCriarAssinaturaDialog" :visibility="visibilidadeAppCriarAssinaturaDialog" />
        <app-adicionar-signatarios @close="fecharAdicionarSignatariosDialog"
          :visibility="visibilidadeAppAdicionarSignatariosDialog" :aluguel="aluguelSelected" :venda="vendaSelected"
          :assinatura="assinaturaSelected" />
      </el-container>
    </el-col>
  </el-row>
</template>
  
<script>
import { mapActions, mapState } from 'vuex';

import { STATUS_ASSINATURA, TIPO_SIGNATARIO_ALUGUEL, TIPO_SIGNATARIO_VENDA, TIPO_SIGNATARIO_IMOVEL_ALUGUEL, TIPO_DE_ASSINATURA, STATUS_ASSINATURA_SIGNATARIO} from '../../util/constantes'
import AppCriarAssinatura from './dialogs/CriarAssinatura.vue'
import AppAdicionarSignatarios from './dialogs/AdicionarSignatarios.vue'
import Util from '../../util/funcoes'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    AppCriarAssinatura,
    AppAdicionarSignatarios,
    FontAwesomeIcon
  },

  data() {
    return {
      assinaturaPesquisa: {
        status: 'EM_PROCESSO'
      },

      aluguelSelected: undefined,
      vendaSelected: undefined,
      assinaturaSelected: undefined,

      conteudo: undefined,
      visibilidadeAppCriarAssinaturaDialog: false,
      visibilidadeAppAdicionarSignatariosDialog: false,
      exibirMenuColapsado: false,

      idsExibirSignatario: [],

      loadingAlugueis: false,
      loadingVendas: false,
      loadingImoveis: false,
      loadingVistorias: false,
    }
  },

  created() {
    this.listarAssinaturasHandler();
  },

  computed: {
    ...mapState('assinaturaEletronicaStore', {
      listaAssinaturas(state) { return state.listaAssinaturas },
      listaAlugueis(state) { return state.listaAlugueis },
      listaVendas(state) { return state.listaVendas },
      listaImoveis(state) { return state.listaImoveisAluguel },
      listaVistorias(state) { return state.listaVistorias }
    }),

    statusAssinatura() {
      return STATUS_ASSINATURA;
    },
    tiposSignatarioAluguel() {
      return TIPO_SIGNATARIO_ALUGUEL;
    },
    tiposSignatarioVenda() {
      return TIPO_SIGNATARIO_VENDA;
    },
    tiposSignatarioImovelAluguel() {
      return TIPO_SIGNATARIO_IMOVEL_ALUGUEL;
    },
    tipoDeAssinatura() {
      return TIPO_DE_ASSINATURA;
    },
    statusAssinaturaSignatario() {
      return STATUS_ASSINATURA_SIGNATARIO
    }
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('assinaturaEletronicaStore', [
      'listarAssinaturas',
      'solicitarAssinaturas',
      'listarAlugueis',
      'listarVendas',
      'listarImoveis',
      'listarVistorias'
    ]),

    exibirCriarAssinaturaDialog() {
      this.visibilidadeAppCriarAssinaturaDialog = true
    },
    fecharCriarAssinaturaDialog() {
      this.visibilidadeAppCriarAssinaturaDialog = false;
    },
    exibirAdicionarSignatariosDialog(row) {
      this.aluguelSelected = row.aluguel
      this.vendaSelected = row.venda
      this.assinaturaSelected = row

      this.visibilidadeAppAdicionarSignatariosDialog = true;
    },
    fecharAdicionarSignatariosDialog() {
      this.visibilidadeAppAdicionarSignatariosDialog = false;
    },


    listarAssinaturasHandler() {
      this.showLoading();
      this.listarAssinaturas(this.assinaturaPesquisa)
        .then(resultado => {
          switch (resultado.status) {
            case 'SUCESSO':
              break;
            case 'ERRO':
              this.$message.error(resultado.mensagem)
              break;
            default:
              this.$message.error(resultado.mensagem)
          }
        }).catch(() => {
          this.$message.error('Erro ao se comunicar com o servidor.')
        }).finally(() => {
          this.hideLoading();
        })
    },

    solicitarAssinaturasHandler(assinatura) {
      const payload = {
        id: assinatura.id
      }

      this.showLoading();

      this.solicitarAssinaturas(payload)
        .then(resultado => {
          switch (resultado.status) {
            case 'SUCESSO':
              this.$message.success(resultado.mensagem);
              break
            case 'ERRO':
              this.$message.error(resultado.mensagem);
              break
          }
        }).catch(() => {
          this.$message.error('Erro ao comunicar-se com o servidor');
        }).finally(() => {
          this.hideLoading();
        })

    },

    showSignatarios(id) {
      if (this.idsExibirSignatario.includes(id)) {
        const indice = this.idsExibirSignatario.indexOf(id);

        this.idsExibirSignatario.splice(indice, 1);
        return;
      }

      this.idsExibirSignatario.push(id);
    },

    getLabel(array, label) {
      return Util.getLabel(array, label)
    },

    recuperarAlugueisSelect(queryString) {
      let payload = { idNaImobiliaria: queryString }
      this.loadingAlugueis = true;
      this.listarAlugueis(payload)
      .then(() => {
        this.loadingAlugueis = false;
      }).catch(() => {
        this.loadingAlugueis = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },

    recuperarVendasSelect(queryString) {
      let payload = { imovel: { idNaImobiliaria: queryString } }
      this.loadingVendas = true;
      this.listarVendas(payload)
      .then(() => {
        this.loadingVendas = false;
      }).catch(() => {
        this.loadingVendas = false;
        this.$message.error("Não foi possível conectar-se com o servidor")
      });
    },

    recuperarImoveisSelect(queryString) {
      let payload = { idNaImobiliaria: queryString  }
      this.loadingImoveisAluguel = true;

      this.listarImoveis(payload)
      .then(() => {
        this.loadingImoveisAluguel = false;
      }).catch(() => {
        this.loadingImoveisAluguel = false;
        this.$message.error("Não foi possível conectar-se com o servidor")
      })
    },

    recuperarVistoriasSelect(queryString) {
      let payload = { status: 'CONCLUIDO' ,aluguel: { idNaImobiliaria: queryString } }

      this.loadingVistorias = true;

      this.listarVistorias(payload)
      .then(() => {
        this.loadingVistorias = false;
      }).catch(() => {
        this.loadingVistorias = false;
        this.$message.error("Não foi possível conectar-se com o servidor")
      })
    },

    limparPesquisa() {
      this.assinaturaPesquisa = {
        status: 'EM_PROCESSO'
      }
    }
  },
}
</script>
  
  
<style>
.el-table::-webkit-scrollbar {
  width: 0px;
}

.bg-row-table .el-table__body-wrapper table tbody tr:hover>td {
  background-color: transparent !important;
  cursor: auto;
}

.bg-row-table .el-table__body-wrapper table tr.current-row>td {
  background-color: transparent !important;
}

 .bg-row-table thead tr {
  display: none !important;
}
</style>

<style scoped>
.height-table {
  max-height: calc(100% - 20px);
  overflow-y: visible;
}

.add-button {
  box-shadow: 2px 2px 8px 0px #d4cece;
  background-color: #3a7297;
}

.add-button:hover {
  background-color: #7cadce;
}

.add-button:focus {
  background-color: #3a7297;
}
.add-button:focus:hover {
  background-color: #7cadce;
}
</style>